
import moment from 'jalali-moment'
import { checkVariablesListForValue } from './useful'

function conditionToFilterConditionGroup(group, variables, resultRef, cb) {

    // console.log("checkConditionGroup", group)
    if (!group) {
        cb()
    }



    let result = resultRef ?? {}
    let currentPartOfResult
    if (group.action && group.action == 'and') {
        result["$and"] = []
        currentPartOfResult = result['$and']
    } else {
        result["$or"] = []
        currentPartOfResult = result['$or']
    }


    let promises = []

    if (group.conditions && typeof group.conditions == 'object') {
        for (const [key, value] of Object.entries(group.conditions)) {
            promises.push(new Promise((resolve, reject) => {

                conditionToFilterOneCondition(value, variables, currentPartOfResult, (condRes) => {

                    // console.log("condRes", condRes)
                    currentPartOfResult.push(condRes)

                    resolve()
                })
            }))
        }
    }

    Promise.all(promises).then(() => {

        cb(result)

    })
}




function conditionToFilterOneCondition(condition, variables, currentPartOfResult, cb) {

    let action = condition.action
    if (action) {
        conditionToFilterConditionGroup(condition, variables, null, (checkRes) => {

            // console.log("checkRes!!",checkRes)
            cb(checkRes)
        })
    } else {

        let source = condition.sourceType?.source ?? condition?.source
        let target = condition.target

        source = conditionToFilterCheckVariables(source, variables)
        target = conditionToFilterCheckVariables(target, variables)

        // console.log("source", source,target)
        cb(conditionToFilterOperator(source, condition.operator, target))

    }
}


function conditionToFilterOperator(vt1, operator, vt2) {

    let v1 = vt1
    let v2 = vt2

    // console.log("operator", operator)
    switch (operator) {
        case '=':
            return { [v1]: v2 }
        case '==':
            return { [v1]: v2 }
        case '===':
            return { [v1]: v2 }
        case '!=':
            return { [v1]: { $ne: v2 } }

        case 'is not':
            return { [v1]: { $ne: v2 } }

        case '!==':
            return { [v1]: { $ne: v2 } }
        case '<':
            return { [v1]: { $lt: v2 } }

        case 'before':
            return { [v1]: { $lt: v2 } }

        case '<=':
            return { [v1]: { $lte: v2 } }
        case '>':
            return { [v1]: { $gt: v2 } }

        case 'after':
            return { [v1]: { $gt: v2 } }

        case '>=':
            return { [v1]: { $gte: v2 } }

        // TO DO: ADD OTHER ONES 
        default:
            return { [v1]: v2 }
    }
}




function conditionToFilterCheckVariables(value, variables) {

    // console.log("value",value)
    // console.log("variables",variables)

    if (value && typeof value == 'string' && value.startsWith('{{')) {

        let final

        // final = checkStaticVariables(value)

        let rawValue = value.replace('{{', '').replace("}}", '')

        // if (final == null && variables && variables[rawValue] != null) {
        //     final = variables[rawValue]
        // }
        // console.log(rawValue, variables)
        final = checkVariablesListForValue(variables, rawValue)?.data ?? null
        // console.log(final)

        // console.log("final",final)

        return final

    } else {
        return value
    }
}



function checkStaticVariables(value) {

    switch (value) {
        case '{{NOW}}':
            return moment(new Date).valueOf()
            break;

        default:
            break;
    }

}




export { conditionToFilterConditionGroup }